/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MessageSendPostRequestDestination } from './MessageSendPostRequestDestination';
import {
    MessageSendPostRequestDestinationFromJSON,
    MessageSendPostRequestDestinationFromJSONTyped,
    MessageSendPostRequestDestinationToJSON,
} from './MessageSendPostRequestDestination';

/**
 * 
 * @export
 * @interface MessageSendPostRequest
 */
export interface MessageSendPostRequest {
    /**
     * 
     * @type {number}
     * @memberof MessageSendPostRequest
     */
    addressed?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageSendPostRequest
     */
    text?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageSendPostRequest
     */
    routing?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MessageSendPostRequest
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSendPostRequest
     */
    senderMmsi?: string;
    /**
     * 
     * @type {MessageSendPostRequestDestination}
     * @memberof MessageSendPostRequest
     */
    destination?: MessageSendPostRequestDestination;
    /**
     * 
     * @type {string}
     * @memberof MessageSendPostRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSendPostRequest
     */
    time?: string;
}

/**
 * Check if a given object implements the MessageSendPostRequest interface.
 */
export function instanceOfMessageSendPostRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MessageSendPostRequestFromJSON(json: any): MessageSendPostRequest {
    return MessageSendPostRequestFromJSONTyped(json, false);
}

export function MessageSendPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSendPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addressed': !exists(json, 'addressed') ? undefined : json['addressed'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'routing': !exists(json, 'routing') ? undefined : json['routing'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'senderMmsi': !exists(json, 'sender_mmsi') ? undefined : json['sender_mmsi'],
        'destination': !exists(json, 'destination') ? undefined : MessageSendPostRequestDestinationFromJSON(json['destination']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'time': !exists(json, 'time') ? undefined : json['time'],
    };
}

export function MessageSendPostRequestToJSON(value?: MessageSendPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addressed': value.addressed,
        'text': value.text,
        'routing': value.routing,
        'type': value.type,
        'sender_mmsi': value.senderMmsi,
        'destination': MessageSendPostRequestDestinationToJSON(value.destination),
        'id': value.id,
        'time': value.time,
    };
}

